import { render, staticRenderFns } from "./reg-success.vue?vue&type=template&id=7fc2f7f6&scoped=true&"
import script from "./reg-success.vue?vue&type=script&lang=js&"
export * from "./reg-success.vue?vue&type=script&lang=js&"
import style0 from "./reg-success.vue?vue&type=style&index=0&id=7fc2f7f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc2f7f6",
  null
  
)

export default component.exports